export const ARTICLE_LIST_FETCH = 'ARTICLE_LIST_FETCH';
export const ARTICLE_LIST_SUCCESS = 'ARTICLE_LIST_SUCCESS';
export const ARTICLE_LIST_FAILURE = 'ARTICLE_LIST_FAILURE';

export const DELETE_ARTICLE_FETCH = 'DELETE_ARTICLE_FETCH';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';
export const DELETE_ARTICLE_FAILURE = 'DELETE_ARTICLE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ArticleList/actionTypes.js